<template>
  <v-container fluid class="pa-4">
    <v-card class="elevation-2">
      <v-toolbar color="brown darken-1" dark dense>
        <v-icon left>category</v-icon>
        <v-toolbar-title>Diğer Zimmet Kalemleri</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn flat class="inv-btn ma-0" @click="openCreate">
          <v-icon left small>add</v-icon>
          Yeni Kalem
        </v-btn>
        <v-btn icon class="ml-2" :loading="loading" @click="load">
          <v-icon>refresh</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text>
        <div class="inv-hint">
          Pirinç çerçeve, gümüş zincir gibi adet bazlı kalemler. Envantere "Diğer Ekle" ile bu kalemlerden seçilerek girilir; ürün reçetelerinde (Envanter Kalemleri) kullanılır.
        </div>

        <v-layout wrap class="inv-stats">
          <v-flex xs4 class="pr-2">
            <div class="inv-stat">
              <div class="inv-stat-label">Toplam Kalem</div>
              <div class="inv-stat-value">{{ items.length }}</div>
            </div>
          </v-flex>
          <v-flex xs4 class="pr-2">
            <div class="inv-stat inv-stat--green">
              <div class="inv-stat-label">Aktif</div>
              <div class="inv-stat-value">{{ activeCount }}</div>
            </div>
          </v-flex>
          <v-flex xs4>
            <div class="inv-stat inv-stat--grey">
              <div class="inv-stat-label">Pasif</div>
              <div class="inv-stat-value">{{ passiveCount }}</div>
            </div>
          </v-flex>
        </v-layout>

        <v-progress-linear v-if="loading" indeterminate color="brown darken-1" class="my-0"></v-progress-linear>

        <div v-if="!items.length && !loading" class="inv-empty">
          <v-icon large color="grey lighten-1">category</v-icon>
          <div>Henüz diğer kalem tanımlanmadı.</div>
        </div>
        <div v-else>
          <div class="inv-card" :class="{ 'inv-card--grey': !item.isActive }" v-for="item in items" :key="item.id">
            <div class="inv-icon" :class="item.isActive ? 'inv-icon--brown' : 'inv-icon--grey'">
              <v-icon color="white" small>category</v-icon>
            </div>

            <div class="inv-card-l">
              <div class="inv-head">
                <span class="inv-title">{{ item.name }}</span>
                <span class="inv-chip" :class="item.isActive ? 'inv-chip--done' : 'inv-chip--grey'">
                  {{ item.isActive ? 'Aktif' : 'Pasif' }}
                </span>
              </div>
            </div>

            <div class="inv-card-r">
              <div class="inv-value">
                <div class="inv-value-num">{{ formatHas(item.hasKarsiligi) }}</div>
                <div class="inv-value-label">gr has / adet</div>
              </div>
              <v-btn icon small color="blue" class="inv-btn ma-0 ml-3" @click="openEdit(item)">
                <v-icon small>edit</v-icon>
              </v-btn>
              <v-btn icon small color="red" class="inv-btn ma-0 ml-1" @click="remove(item)">
                <v-icon small>delete</v-icon>
              </v-btn>
            </div>
          </div>
        </div>
      </v-card-text>
    </v-card>

    <v-dialog v-model="dialog" max-width="460" persistent>
      <v-card>
        <v-card-title class="headline brown darken-1 white--text">
          <v-icon left color="white">category</v-icon>
          {{ editing ? 'Kalem Düzenle' : 'Yeni Diğer Kalem' }}
        </v-card-title>
        <v-card-text class="pa-4">
          <v-text-field v-model="form.name" label="Kalem Adı" placeholder="Örn. Pirinç Çerçeve, Gümüş Zincir" prepend-icon="label" autofocus></v-text-field>
          <v-text-field
            v-model="form.hasKarsiligi"
            label="Has Karşılığı (adet başı gram-has)"
            placeholder="Örn. 0,12"
            prepend-icon="straighten"
            hint="Envantere eklenince adet × bu değer Toplam Has'a girer. Yoksa 0 bırakın."
            persistent-hint
          ></v-text-field>
          <v-switch v-model="form.isActive" :label="form.isActive ? 'Aktif' : 'Pasif'" color="green"></v-switch>
        </v-card-text>
        <v-card-actions class="pa-3">
          <v-spacer></v-spacer>
          <v-btn flat color="grey" class="inv-btn" @click="dialog = false">İptal</v-btn>
          <v-btn color="brown darken-1" dark class="inv-btn" :loading="saving" @click="save">Kaydet</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    loading: false,
    saving: false,
    items: [],
    dialog: false,
    editing: false,
    form: { id: null, name: "", isActive: true, hasKarsiligi: "" },
  }),

  computed: {
    activeCount() {
      return this.items.filter(i => i.isActive).length;
    },
    passiveCount() {
      return this.items.filter(i => !i.isActive).length;
    },
  },

  created() {
    this.load();
  },

  methods: {
    async load() {
      this.loading = true;
      try {
        this.items = (await this.$store.dispatch("inventory/getOtherItems")) || [];
      } catch (e) {
        this.notify("Kalemler yüklenemedi: " + this.errMsg(e));
      } finally {
        this.loading = false;
      }
    },
    openCreate() {
      this.editing = false;
      this.form = { id: null, name: "", isActive: true, hasKarsiligi: "" };
      this.dialog = true;
    },
    openEdit(item) {
      this.editing = true;
      this.form = {
        id: item.id,
        name: item.name,
        isActive: item.isActive,
        hasKarsiligi: item.hasKarsiligi ? String(item.hasKarsiligi).replace(".", ",") : "",
      };
      this.dialog = true;
    },
    async save() {
      if (!this.form.name || !this.form.name.trim()) { this.notify("Kalem adı girin."); return; }
      this.saving = true;
      try {
        const dto = { name: this.form.name, isActive: this.form.isActive, hasKarsiligi: this.parseHas(this.form.hasKarsiligi) };
        if (this.editing) {
          await this.$store.dispatch("inventory/updateOtherItem", { id: this.form.id, dto });
        } else {
          await this.$store.dispatch("inventory/createOtherItem", dto);
        }
        this.dialog = false;
        await this.load();
      } catch (e) {
        this.notify("Hata: " + this.errMsg(e));
      } finally {
        this.saving = false;
      }
    },
    async remove(item) {
      if (!confirm(`'${item.name}' silinsin mi?`)) return;
      try {
        await this.$store.dispatch("inventory/deleteOtherItem", item.id);
        await this.load();
      } catch (e) {
        this.notify("Hata: " + this.errMsg(e));
      }
    },
    parseHas(s) {
      if (s == null || s === "") return 0;
      const n = parseFloat(String(s).trim().replace(",", "."));
      return Number.isNaN(n) || n < 0 ? 0 : n;
    },
    formatHas(v) {
      if (v == null || Number(v) === 0) return "—";
      return Number(v).toLocaleString("tr-TR", { maximumFractionDigits: 4 });
    },
    errMsg(e) {
      return (e && e.response && e.response.data && e.response.data.message) || (e && e.message) || "Bilinmeyen hata";
    },
    notify(msg) {
      this.$store.state.dialog = true;
      this.$store.state.message = msg;
    },
  },
};
</script>
